import React from "react";
import {createRoot} from "react-dom/client";
import ReactGA from "react-ga4";

import {createBrowserRouter, RouterProvider} from "react-router-dom";

import AdminLayout from "./layouts/Admin";
import PublicLayout from "./layouts/Public";
import AuthLayout from "./layouts/Auth";
import awsconfig from "./configs/awsconfig.json";
import {createRoutesFromElements, Route} from "react-router-dom";

// Load critical CSS immediately
import "./assets/scss/black-dashboard-react.scss";
// Load non-critical CSS asynchronously
import("./assets/demo/demo.css");
import("./assets/css/nucleo-icons.css");
import("@fortawesome/fontawesome-free/css/all.min.css");

import ThemeContextWrapper from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";
import NotificationProvider from "./components/NotificationProvider/NotificationProvider";
import {AuthProvider} from "./contexts/AuthContext";
import ShutdownBanner from "./components/ShutdownBanner/ShutdownBanner";

// Import color scheme manager for development tools
import "./utils/colorSchemeManager";

//console.log(`ReactGA.initialize: ${awsconfig.Environment.name}`);

if (awsconfig.Environment.name === "prod") {
  ReactGA.initialize(awsconfig.Environment.googleAnalyticsId);
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Failed to find the root element");
}
const root = createRoot(container);

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/public/:id/:isPreview?" element={<PublicLayout />} />
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="/*" element={<AdminLayout />} />
    </>
  )
);

root.render(
  <ThemeContextWrapper>
    <BackgroundColorWrapper>
      <NotificationProvider>
        <AuthProvider>
          <ShutdownBanner />
          <RouterProvider router={router} />
        </AuthProvider>
      </NotificationProvider>
    </BackgroundColorWrapper>
  </ThemeContextWrapper>
);
